<template>
  <div class="newDetails">
    <div class="d-main tabNav">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/new' }">
          新闻中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="newTitle">{{ New.title }}</div>
      <div class="newTime">发布时间：{{ New.lastUpdateTime | timeData }}</div>
      <div class="newImg">
        <img :src="New.cover" alt />
      </div>
      <div class="newText" v-html="New.content"></div>
    </div>
    <div class="he50"></div>
    <div class="he50"></div>
  </div>
</template>

<script>
import { getActivityDetail } from "@/api/api.js";

export default {
  data() {
    return {
      title: "",
      New: {
        content: "",
        cover: "",
        createTime: "",
        endTime: "",
        id: "",
        isShow: "",
        lastUpdateTime: "",
        num: "",
        price: "",
        startTime: "",
        title: ""
      }
    };
  },
  mounted() {
    this.toPage(this.$route.query.title, this.$route.query.id);
  },
  methods: {
    toPage(val, id) {
      if (val && id) {
        this.title = val;
        this.getActivityDetail(id);
      } else {
        this.$router.push({ name: "pcnew" });
      }
    },
    getActivityDetail(id) {
      getActivityDetail(id).then(res => {
        if (res.code === 0) {
          this.New = {
            content: res.data.content,
            cover: res.data.cover,
            createTime: res.data.createTime,
            endTime: res.data.endTime,
            id: res.data.id,
            isShow: res.data.isShow,
            lastUpdateTime: res.data.lastUpdateTime,
            num: res.data.num,
            price: res.data.price,
            startTime: res.data.startTime,
            title: res.data.title
          };
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    toLink(item) {
      if (!item) return;
      this.getActivityDetail(item.id);
    }
  }
};
</script>

<style lang="less">
.newDetails {
  .tabNav {
    margin: 70px auto 40px;
  }
  .newTitle {
    margin: 30px 0 10px;
    font-size: 28px;
    color: rgba(52, 52, 52, 1);
  }
  .newTime {
    font-size: 16px;
    color: rgba(102, 102, 102, 1);
  }
  .newImg {
    width: 100%;
    margin: 20px 0;
    text-align: center;
  }
  .newText {
    width: 100%;
  }
  .line {
    margin: 30px 0 10px;
    width: 100%;
    border: 1px dashed rgba(191, 195, 199, 1);
  }
  .newlink {
    display: flex;
    justify-content: space-between;
    span {
      font-size: 16px;
      color: rgba(108, 44, 102, 1);
      line-height: 28px;
      cursor: pointer;
    }
  }
}
</style>
